/**
 * 专利管理 专利检索
 */
<template>
  <div class="ph-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <!-- <el-breadcrumb-item>专利检索</el-breadcrumb-item> -->
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <!-- <dv-border-box-9> -->
    <div class="search-top">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="申请日:">
           <!-- <el-select size="small" v-model="formInline.sqrqType" style="width:100px" placeholder="请选择">
            <el-option v-for="type in sqrqType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item>
        <el-date-picker size="small" v-model="formInline.sqrq_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:140px"> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker size="small" v-model="formInline.sqrq_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:140px"> </el-date-picker>
        </el-form-item>
        <el-form-item label="公开(公告)日:">
          <!-- <el-select size="small" v-model="formInline.gkrType" style="width:100px" placeholder="请选择">
            <el-option v-for="type in gkrType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item>
        <el-date-picker size="small" v-model="formInline.gkr_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:140px" clearable> </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-date-picker size="small" v-model="formInline.gkr_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:140px" clearable> </el-date-picker>
        </el-form-item>
        <el-form-item label="代理人:">
          <el-input size="small" v-model="formInline.agent"  style="width:120px" placeholder="输入代理人" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item style="margin-left: 15px;">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">检索</el-button>
          <el-button size="small" type="primary" @click="exportCheck" title="导出勾选中的数据">导出</el-button>
          <el-button size="small" type="primary" @click="exportAll" title="导出满足条件的数据">全部导出</el-button>
          <el-button size="small" type="danger" @click="deleteCheckPatent" title="删除勾选中的数据">删除</el-button>
        </el-form-item> -->
        <!-- <el-form-item label="申请人:" style="margin-left: 15px;">
          <el-select v-model="formInline.sqr"
          style="width:150px;height:32px;"
          placeholder="请选择申请人"
          clearable
          filterable
          @blur="selectBlurSqr"
          @clear="selectClearSqr"
          @change="selectChangeSqr">
            <el-option v-for="item in searchSqrData" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
          <el-form-item label="申请人:" style="margin-left: 15px;">
            <el-input size="small" v-model="formInline.sqr"  style="width:120px" placeholder="输入申请人" clearable></el-input>
          </el-form-item>
        <!-- <el-form-item label="发明人:" style="margin-left: 15px;">
          <el-select v-model="formInline.fmr"
          style="width:150px;height:32px;"
          placeholder="请选择发明人"
          clearable
          filterable
          @blur="selectBlurFmr"
          @clear="selectClearFmr"
          @change="selectChangeFmr">
            <el-option v-for="item in searchFmrData" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
          <el-form-item label="发明人:" style="margin-left: 15px;">
            <el-input size="small" v-model="formInline.fmr"  style="width:120px" placeholder="输入发明人" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请号:">
            <el-input size="small" v-model="formInline.zlid"  style="width:120px" placeholder="输入专利号" clearable></el-input>
          </el-form-item>
          <el-form-item label="专利名称:">
            <el-input size="small" v-model="formInline.zlmc"  style="width:150px" placeholder="输入专利名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="代理机构:">
            <el-input size="small" v-model="formInline.dljg"  style="width:150px" placeholder="输入代理机构" clearable></el-input>
          </el-form-item>
          <el-form-item label="专利类型:" style="margin-left: 15px;">
            <el-select size="small" v-model="formInline.zllx" style="width:100px" placeholder="请选择">
              <el-option v-for="type in zllx" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="法律状态:">
            <el-select size="small" v-model="formInline.flzt" style="width:100px" placeholder="请选择">
              <el-option v-for="type in legal" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公开(公告)号:">
            <el-input size="small" v-model="formInline.zlwyid"  style="width:150px" placeholder="输入公开(公告)号" clearable></el-input>
          </el-form-item>
          <el-form-item label="申请人地址:">
            <el-input size="small" v-model="formInline.applicant_address"  style="width:150px" placeholder="输入申请人地址" clearable></el-input>
          </el-form-item>

      </el-form>
    </div>
    <!-- </dv-border-box-9> -->
    <div>
      <el-form>
        <div style="min-width: 1200px;">
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">检索</el-button>
            <el-button size="small" type="primary" @click="addCheckMonitor" title="批量监控勾选的专利">监控</el-button>
            <el-button size="small" type="info" @click="emptySearch">清空</el-button>
            <el-button size="small" type="danger" @click="deleteCheckPatent" title="删除勾选中的数据">删除</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- <div style="display: flex;"> -->
      <!-- <div style="width: auto;"> -->
        <!-- 右侧数据显示列表 -->
        <!--列表-->
        <el-table size="small" @selection-change="handleSelectionChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" type="index" label="序号" width="50">
          </el-table-column>
          <!-- <el-table-column prop="uid" v-if="idShow">
          </el-table-column> -->
          <el-table-column align="center" prop="zlmc" label="标题" min-width="120">
          </el-table-column>
          <el-table-column align="center" prop="id" label="专利号" max-width="90">
          </el-table-column>
          <el-table-column align="center" prop="zllx" label="类型" max-width="90">
          </el-table-column>
          <el-table-column align="center" prop="sqr" label="申请人" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="sqrq" label="申请日" min-width="80">
          </el-table-column>
          <el-table-column align="center" prop="gkr" label="公开(公告)日" min-width="80">
          </el-table-column>
          <el-table-column align="center" prop="fmr" label="发明人" min-width="100">
          </el-table-column>
          <el-table-column align="center" prop="flzt" label="状态" min-width="80">
          </el-table-column>
          <!-- <el-table-column align="center" prop="agent" label="代理人" min-width="80">
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="agency" label="代理机构" min-width="80">
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="current_assignee" label="当前权利人" min-width="100">
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="applicant_address" label="申请人地址" min-width="100" show-overflow-tooltip>
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="category" label="缴费类目" min-width="80">
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="money" label="缴费金额" min-width="80">
          </el-table-column> -->
          <!-- <el-table-column align="center" prop="date_time" label="截止时间" min-width="80">
          </el-table-column> -->
          <el-table-column align="center" label="操作" min-width="180">
            <template slot-scope="scope">
              <el-button size="mini" @click="patentInfo(scope.$index, scope.row)" title="查看详情">详情</el-button>
              <el-button type="primary" size="mini" @click="addMonitor(scope.$index, scope.row)" v-if="scope.row.is_monitor == '1'" title="添加监控">监控</el-button>
              <el-button type="primary" size="mini" @click="addMonitor(scope.$index, scope.row)" v-if="scope.row.is_monitor == '2'" title="已监控" disabled>已监控</el-button>
              <el-button size="mini" type="danger" @click="deletePatent(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      <!-- </div> -->
    <!-- </div> -->

    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="infoFormVisible" width="60%" @click='closeDialog("info")'>
      <el-form label-width="80px" ref="infoForm" :model="infoForm" :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item label="专利名称" prop="zlmc">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" placeholder="专利名称" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
              <el-input size="small" v-model="infoForm.applicant" auto-complete="off" placeholder="申请人" disabled></el-input>
            </el-form-item>
            <el-form-item label="发明人" prop="inventor">
              <el-input size="small" v-model="infoForm.inventor" auto-complete="off" placeholder="发明人" disabled></el-input>
            </el-form-item>
            <el-form-item label="当前权人" prop="currentAssignee">
              <el-input size="small" v-model="infoForm.currentAssignee" auto-complete="off" placeholder="当前权人" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请日" prop="sqrq">
              <el-input size="small" v-model="infoForm.sqrq" auto-complete="off" placeholder="申请日" disabled></el-input>
            </el-form-item>
            <el-form-item label="待缴类目" prop="category">
              <el-input size="small" v-model="infoForm.category" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请地址" prop="applicantAddress">
              <el-input size="small" v-model="infoForm.applicantAddress" auto-complete="off" placeholder="申请地址" disabled></el-input>
            </el-form-item>
          </el-col>
         <el-col :span="8">
           <el-form-item label="专利号" prop="zlid">
              <el-input size="small" v-model="infoForm.zlid" auto-complete="off" placeholder="专利号" disabled></el-input>
            </el-form-item>
            <el-form-item label="公开号" prop="zlwyid">
              <el-input size="small" v-model="infoForm.zlwyid" auto-complete="off" placeholder="公开公告号" disabled></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="currentStatus">
              <el-input size="small" v-model="infoForm.currentStatus" auto-complete="off" placeholder="状态" disabled></el-input>
            </el-form-item>
             <el-form-item label="代理人" prop="agent">
              <el-input size="small" v-model="infoForm.agent" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="公开日" prop="gkr">
              <el-input size="small" v-model="infoForm.gkr" auto-complete="off" placeholder="公开日" disabled></el-input>
            </el-form-item>
            <el-form-item label="待缴金额" prop="money">
              <el-input size="small" v-model="infoForm.money" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item label="专利类型" prop="zllx">
              <el-input size="small" v-model="infoForm.zllx" auto-complete="off" placeholder="专利类型" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请类型" prop="applicant_type">
              <el-input size="small" v-model="infoForm.applicant_type" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="主分类号" prop="mainIpc">
              <el-input size="small" v-model="infoForm.mainIpc" auto-complete="off" placeholder="IPC主分类号" disabled></el-input>
            </el-form-item>
            <el-form-item label="代理机构" prop="agency">
              <el-input size="small" v-model="infoForm.agency" auto-complete="off" placeholder="代理机构" disabled></el-input>
            </el-form-item>
            <el-form-item label="IPC" prop="ipc">
              <el-input size="small" v-model="infoForm.ipc" auto-complete="off" placeholder="IPC" disabled></el-input>
            </el-form-item>
            <el-form-item label="截止日期" prop="date_time">
              <el-input size="small" v-model="infoForm.date_time" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
         </el-col>
        </el-row>
        <el-form-item>
        <el-button @click="submitInfoForm()" style="float: right;">确定</el-button>
      </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {
  searchPatent,
  searchLegalStatus,
  webUrl,
  searchApplicant,
  searchInventor,
  getDefaultApplicant,
  getDefaultInventor,
  exportCheck,
  exportAll,
  deletePatent,
  deleteCheckPatent,
  patentRetrieval,
  getPatentInfo,
  addPatentMonitor,
  addCheckPatentMonitor
} from '../../api/patentMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      idShow: false, //列表uid不显示
      infoFormVisible: false, //详情界面是否显示
      title: '',
      multipleSelection: [],
      sqr: '123',
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      // 申请日期类型
      sqrqType: [
        { key: '时间段', value: 1 },
        { key: '日期', value: 2 },
      ],
      gkrType: [
        { key: '时间段', value: 1 },
        { key: '日期', value: 2 },
      ],
      searchSqrData: [],
      searchFmrData: [],
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        real_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },

      // 专利类型
      zllx: [
        { key: '全部', value: '' },
        { key: '发明公开', value: '发明公开' },
        { key: '发明授权', value: '发明授权' },
        { key: '实用新型', value: '实用新型' },
        { key: '外观设计', value: '外观设计' },
      ],
      // 法律状态
      legal: [
        { key: '全部', value: '' },
        { key: '有效', value: '有效专利' },
        { key: '失效', value: '失效专利' },
        { key: '审中', value: '实质审查' },
        { key: '无效', value: '无效专利' },
        { key: '公开', value: '公开' },
      ],
      // 角色
      roleArr: [],
      searchRoleArr: [],
      // 请求数据参数
      formInline: {
        page: 1,
        ps: 10,
        sqr: '',
        fmr: '',
        zllx: '',
        flzt: '',
        dljg: '',
        sqrq_start_time: '',
        sqrq_end_time: '',
        gkr_start_time: '',
        gkr_end_time: '',
        zlid: '',
        zlmc: '',
        applicant_address: '',
        zlwyid: '',
        agent: ''
      },
      infoForm: [],
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
 
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据方法
    getdata(parameter) {
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
       this.loading = true
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       patentRetrieval(parameter)
       .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
      //  .catch(err => {
      //     this.loading = false
      //     this.$message.error('登陆已过期,请重新登陆!')
      //   })
    },
    // 获取法律状态
    getlegal(){
      searchLegalStatus()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.legal = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    getDefaultApplicant(){
      getDefaultApplicant()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.searchSqrData = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    getDefaultInventor(){
      getDefaultInventor()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.searchFmrData = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    // 查询申请人
    querySearchSqr(queryString,callback){
        let searchSqr = queryString
        console.log(searchSqr)
        let sqr = []
        if(searchSqr.length > 0){
             searchApplicant({'applicantSearch':searchSqr})
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                    sqr = res.data
                    callback(sqr);  
                }
            })
        }else{
          callback(sqr);  
        }
             
    },
    // 查询发明人
    querySearchFmr(queryString,callback){
      let searchFmr = queryString
        console.log(searchFmr)
        let fmr = []
        if(searchFmr.length > 0){
             searchInventor({'inventorSearch':searchFmr})
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                    fmr = res.data
                    callback(fmr);  
                }
            })
        }else{
          callback(fmr);  
        }
    },
    // 模糊搜索申请人
    selectBlurSqr(e){
      if(e.target.value !== ''){
        console.log(e)
      }
    },
    // 清空申请人
    selectClearSqr(){

    },
    // 选择申请人
    selectChangeSqr(val){

    },
    // 模糊搜索发明人
    selectBlurFmr(e){
      if(e.target.value !== ''){
        console.log(e)
      }
    },
    // 清空发明人
    selectClearFmr(){

    },
    // 选择发明人
    selectChangeFmr(val){

    },
    // 分页插件事件
    callFather(parm) {
      if(parm.pageSize > 50){
        parm.pageSize = 50
        this.$message({
          type: 'info',
          message: '单次查询数据不能超过50条!'
        })
      }
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.pageparm.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.title = '专利信息详情'
      this.infoForm = row
      this.infoFormVisible = true
    },
    // 删除专利(单个)
    deletePatent(index, row){
      console.log(row)
      this.$confirm('确定确定删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(()=>{
       deletePatent({id:row.id})
          .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

    }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除专利(勾选)
    deleteCheckPatent(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定删除勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        deleteCheckPatent(exportParam)
            .then(res => {
              res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    submitInfoForm(){
      this.infoFormVisible = false
    },
    // 导出勾选中的数据
    exportCheck(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定导出勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        exportCheck(exportParam)
                .then(res => {
                  res = checkLogin(res)
                  if (res.code == 200) {
                    location.href = res.data.url
                    this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 导出满足条件的数据
    exportAll(){
      this.$confirm('确定导出所有满足条件的数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
      })
      .then(() => {
          if(this.formInline.sqrq_start_time == null){
              this.formInline.sqrq_start_time = ''
          }
          if(this.formInline.sqrq_end_time == null){
              this.formInline.sqrq_end_time = ''
          }
          if(this.formInline.sqrq_date == null){
              this.formInline.sqrq_date = ''
          }
          if(this.formInline.gkr_start_time == null){
              this.formInline.gkr_start_time = ''
          }
          if(this.formInline.gkr_end_time == null){
              this.formInline.gkr_end_time = ''
          }
          if(this.formInline.gkr_date == null){
              this.formInline.gkr_date = ''
          }
            exportAll(this.formInline)
              .then(res => {
                if (res.code == 200) {
                  location.href = res.data.url
                  this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'info') {
        this.infoFormVisible = false
      }
    },
    // 清空搜索值
    emptySearch(){
      this.formInline.sqr = '',
      this.formInline.fmr = '',
      this.formInline.zllx = '',
      this.formInline.flzt = '',
      this.formInline.dljg = '',
      this.formInline. sqrq_start_time = '',
      this.formInline.sqrq_end_time = '',
      this.formInline.gkr_start_time = '',
      this.formInline.gkr_end_time = '',
      this.formInline.zlid = '',
      this.formInline.zlmc = '',
      this.formInline.applicant_address = '',
      this.formInline.zlwyid = '',
      this.formInline.agent = ''
    },
    // 专利详情
    patentInfo(i,item){
      // console.log(item)
      getPatentInfo({zlid:item.id,zlwyid:item.zlwyid})
      .then(res=>{
        if(res.code == 200){
          console.log(res)
          this.title = '专利信息详情'
          this.infoFormVisible = true
          this.infoForm = res.data
        }else{
          this.$message({
              type: 'info',
              message: res.msg
          })
        }
      })
      // .catch(err=>{
      //     this.$message({
      //         type: 'error',
      //         message: '系统错误!'
      //     })
      // })
    },
    // 添加监控
    addMonitor(i,item){
      this.$confirm('确定监控此专利吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        addPatentMonitor({zlid:item.id,zlwyid:item.zlwyid})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.userData[i].is_monitor = 2
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        // .catch(err=>{
        //   this.$message({
        //       type: 'error',
        //       message: '系统错误!'
        //   })
        // })
      })
      .catch(err=>{
        this.$message({
            type: 'info',
            message: '已取消!'
        })
      })
    },
    // 添加监控(勾选中)
    addCheckMonitor(){
      const checkedArr = this.multipleSelection;
      // console.log(checkedArr)
      // return false
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.zlwyid)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定批量监控勾选的专利吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        addCheckPatentMonitor({ids:idStr})
        .then(res => {
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.userData.forEach(function(item,index){
              if(idsArr.indexOf(item.zlwyid) > -1){
                item.is_monitor = 2
              }
            })
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
        // .catch(err=>{
        //   this.$message({
        //     type: 'error',
        //     message: '系统错误!'
        //   })
        // })
      })
      .catch(err => {
          this.$message({
            type: 'info',
            message: '取消'
          })
      })
    },
    // 取消监控
    delMonitor(i,item){

    }
  }
}
</script>

<style scoped>
.ph-container {
  margin: 0 auto;
  max-width: 1680px;
  min-width: 1024px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;

}
.el-form-item {
    margin-bottom: 10px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/patent/search.vue